import SurveyQuestionConditionTab from './SurveyQuestionConditionTab.vue';
import SurveyQuestionDetailsTab from './SurveyQuestionDetailsTab.vue';
import SurveyQuestionOptionsTab from './SurveyQuestionOptionsTab.vue';
import SurveyQuestionPermissionTab from './SurveyQuestionPermissionTab.vue';
import SurveyQuestionValidationTab from './SurveyQuestionValidationTab.vue';

export default {
  SurveyQuestionConditionTab,
  SurveyQuestionDetailsTab,
  SurveyQuestionOptionsTab,
  SurveyQuestionPermissionTab,
  SurveyQuestionValidationTab,
};
